import { HttpAdapter, AnyAdapter } from './adapter';
import { Product } from '../models/product';
import { HttpResponse } from 'vue-resource/types/vue_resource';
import { Vector2 } from '@babylonjs/core';
import { ProductType } from '@/store/modules/product';

class ProductAdapter implements HttpAdapter<Product>, AnyAdapter<Product> {

    public adapt(input: HttpResponse): Product {
        const data = input.data;
        return this.adaptAny(data);
    }

    public adaptAny(input: any): Product {
        const x = input.shape.x;
        const y = input.shape.y;
        const shape = new Vector2(x, y);
        const type = this.getType(input.type);
        const result = {
            model: input.model,
            shape,
            light: input.light,
            textures: input.textures,
            insides: input.insides,
            fronts: input.fronts,
            handles: input.handles,
            legs: input.legs,
            width: input.width,
            height: input.height,
            depth: input.depth,
            name: input.name,
            type,
            cameraPosition: input.cameraPosition,
            appPreset: input.appPreset,
            appPresetInterior: input.appPresetInterior,
        };
        return result;
    }

    private getType(type: any): ProductType {
        return type ? type : ProductType.CHEST_FURNITURE;
    }
}

export const productAdapter = new ProductAdapter();
